<template>
  <div class="panel bgPanel mt1x cb h28x">
    <loading v-show="isLoading"></loading>
    <div class="title title-bg">
      <span :title="$t('word1470',['天气'])">{{$t("word1470",["天气"])}}</span>
      <div class="tool" v-if="weatherState.length">
        <button type="button" :title="$t('cmd7',['刷新'])" class="fR fSub ml05x" @click="_weather()">
          <Icon name="refresh" class="w1x h1x" :sizeBase="'m'" />
        </button>
        <div class="fR cSub">
          <span :title="$t('word13',['更新于'])">{{$t('word13',['更新于'])+":&nbsp;"}}</span><span :title="timeFormat(weatherState[0].datetime,'utc','%Y/%m/%d %H:%M:%S',{offset:this.basicInfo.region.timezone})">{{timeFormat(weatherState[0].datetime,'utc','%Y/%m/%d %H:%M:%S',{offset:this.basicInfo.region.timezone})}}</span>
        </div>
      </div>
    </div>
    <div id="weatherInfo" class="pt1x pb1x pl1x pr1x" v-if="weatherState.length && !error">
      <div class="tableSys bdSub-bottom vaB_E pb1x">
        <div class="w36pct">
          <div class="taC">
            <svg class="w5x h5x alpha-hight fillMain dpIB fSub">
              <use :xlink:href="'#ico-weather-'+weatherState[0].weatherPic||'unknown'"></use>
            </svg>
          </div>
          <div class="taC mt05x">
            <div class="dpIB" :title="floatFix(tempChange(preference.tempUnit,weatherState[0].temp)[1],1,tempChange(preference.tempUnit,weatherState[0].temp)[2])"><span class="fs18x">{{floatFix(tempChange(preference.tempUnit,weatherState[0].temp)[1],1)}}</span>{{tempChange(preference.tempUnit,weatherState[0].temp)[2]}}</div>&nbsp;&nbsp;&nbsp;&nbsp;
            <div class="dpIB fs14x" :title="getTypeText(weatherState[0].weatherPic,'weatherState')">{{getTypeText(weatherState[0].weatherPic,'weatherState')}}</div>
          </div>
        </div>
        <div>
          <div :title="getWeek(0)" class="mb1x">{{getWeek(0)}}</div>
          <div class="mb1x">{{floatFix(tempChange(preference.tempUnit,weatherState[0].tempMin)[1],1,tempChange(preference.tempUnit,weatherState[0].tempMin)[2])}}~{{floatFix(tempChange(preference.tempUnit,weatherState[0].tempMax)[1],1,tempChange(preference.tempUnit,weatherState[0].tempMax)[2])}}</div>
          <div class="mb1x vaM_E"><span :title="$t('word879',['风速'])">{{$t('word879',['风速'])}}: </span><span class="cMain textCut" :title="floatFix(weatherState[0].windSpeed,1,' m/s')">{{floatFix(weatherState[0].windSpeed,1," m/s")}}</span></div>
          <div class="dpIB_E w49pct_E">
            <div><span :title="$t('word182',['日出时间'])" class="textCut">{{$t("word182",["日出时间"])}}:&nbsp;</span><span class="cMain textCut" :title="TimeFormat(weatherState[0].sunrise)">{{TimeFormat(weatherState[0].sunrise)}}</span></div>
            <div><span :title="$t('word183',['日落时间'])" class="textCut">{{$t("word183",["日落时间"])}}:&nbsp;</span><span class="cMain textCut" :title="TimeFormat(weatherState[0].sunset)">{{TimeFormat(weatherState[0].sunset)}}</span></div>
          </div>
        </div>
      </div>
      <!-- <div class="pl1x bdSub-bottom">
						<div class="mb05x tableSys">
								<div class="w5x">
										<svg class="w5x h5x alpha-hight fillMain dpIB fSub">
												<use :xlink:href="'#ico-weather-'+weatherState[0].weatherPic||'unknown'"></use>
										</svg>
								</div>
								<div class="ml1x taL lh12 dpIB vaM pl1x dpIB_E vaT_E">
										<div class="mr2x">
												<div class="fs18x mb05x" :title="floatFix(weatherState[0].temp,1,' ℃')">{{floatFix(weatherState[0].temp,1," ℃")}}</div>
												<div :title="weahterRegion?weahterRegion:'--'">{{weahterRegion?weahterRegion:'--'}}&nbsp;<i class="fa fa-map-marker fs12x cSub mr5"></i></div>
										</div>
										<div>
												<div class="mb05x" :title="getTypeText(weatherState[0].weatherPic,'weatherState')">{{getTypeText(weatherState[0].weatherPic,'weatherState')}}</div>
												<div class="mb05x">
														<span :title="$t('word1475',['今天'])">{{$t("word1475",["今天"])}}</span> &nbsp;&nbsp;
														<span :title="getWeek(0)">{{getWeek(0)}}</span>
												</div>
												<div>
														<span :title="new Date().getMonth()+1+'/'+new Date().getDate()">{{new Date().getMonth()+1+'/'+new Date().getDate()}}</span>
												</div>
										</div>
								</div>
						</div>
						<ul class="clearfix w50pct_E fL_E pb1x_E">
								<li class="tableSys vaM_E">
										<div class="w2x h2x icoSys"><svg class="ico"><use xlink:href="#temp"></use></svg></div><div :title="getLanguageStr('word1763','温度范围')" class="textCut">{{getLanguageStr('word1763','温度范围')}}</div> <div class="cMain textCut" :title="floatFix(weatherState[0].tempMin,1,' ℃')+'~'+floatFix(weatherState[0].tempMax,1,' ℃')">{{floatFix(weatherState[0].tempMin,1," ℃")}}~{{floatFix(weatherState[0].tempMax,1," ℃")}}</div>
								</li>
								<li class="tableSys vaM_E">
										<div class="w2x h2x icoSys"><svg class="ico"><use xlink:href="#windSpeed"></use></svg></div><div :title="$t('word879',['风速'])" class="textCut">{{$t('word879',['风速'])}}</div><div class="cMain textCut" :title="floatFix(weatherState[0].windSpeed,1,' m/s')">{{floatFix(weatherState[0].windSpeed,1," m/s")}}</div>
								</li>
								<li class="tableSys vaM_E">
										<div class="w2x h2x icoSys"><svg class="ico"><use xlink:href="#sunrise"></use></svg></div><div :title="$t('word182',['日出时间'])" class="textCut">{{$t("word182",["日出时间"])}}</div><div class="cMain textCut" :title="TimeFormat(weatherState[0].sunrise)">{{TimeFormat(weatherState[0].sunrise)}}</div>
								</li>
								<li class="tableSys vaM_E">
										<div class="w2x h2x icoSys"><svg class="ico"><use xlink:href="#sunset"></use></svg></div><div :title="$t('word183',['日落时间'])" class="textCut">{{$t("word183",["日落时间"])}}</div><div class="cMain textCut" :title="TimeFormat(weatherState[0].sunset)">{{TimeFormat(weatherState[0].sunset)}}</div>
								</li>
						</ul>
				</div> -->
      <ul class="clearfix pt1x w33pct_E fL_E">
        <li v-for="(item,index) in weatherState" :key="index">
          <template v-if="index>0 && index<4">
            <div class="pb05x taC" :title="getWeek(index)">
              {{getWeek(index)}}
            </div>
            <div class="taC" :class="{'bdSub-right':index<weatherState.length-2}">
              <div class="dpB_E mb05x_E">
                <span>{{getDay(index)}}</span>
                <svg class="w3x h3x alpha-hight fillMain dpIB fSub">
                  <use :xlink:href="'#ico-weather-'+weatherState[index].weatherPic||'unknown'"></use>
                </svg>
                <br>
                <span :title="floatFix(tempChange(preference.tempUnit,weatherState[index].tempMin)[1],1,'')+'~'+floatFix(tempChange(preference.tempUnit,weatherState[index].tempMax)[1],1,tempChange(preference.tempUnit,weatherState[index].tempMax)[2])">{{floatFix(tempChange(preference.tempUnit,weatherState[index].tempMin)[1],1,"")+'~'+floatFix(tempChange(preference.tempUnit,weatherState[index].tempMax)[1],1,tempChange(preference.tempUnit,weatherState[index].tempMax)[2])}}</span>
                <span :title="weatherState[index].description">{{weatherState[index].description}}</span>
                <div :title="getTypeText(weatherState[index].weatherPic,'weatherState')">{{getTypeText(weatherState[index].weatherPic,'weatherState')}}</div>
                <div class="textCut"><span :title="$t('word879',['风速'])">{{$t('word879',['风速'])}}</span>&nbsp;&nbsp;<span :title="floatFix(weatherState[index].windSpeed,1,' m/s')">{{floatFix(weatherState[index].windSpeed,1," m/s")}}</span></div>
              </div>
            </div>
          </template>
        </li>
      </ul>
    </div>
    <div class="taC" v-if="error">
      <div class="mb2x">
        <img src="/static/image/weather.png" alt="" class="w32pct">
      </div>
      <div class="taC mb2x">{{getLanguageStr('phrase737','天气数据获取失败，请点击"重试"再次获取')}}</div>
      <button type="button" permission-type="none" class="functionBtn sizeM w6x" @click="_weather()">{{getLanguageStr('cmd77','重试')}}</button>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Loading from '@/components/common/ui/Loading'
import { searchAreaList, weatherAddress, weatherState } from '@/api/base.js'
import * as equipmentApi from '@/api/maintain/plant/list'
import * as lib from '@/util/lib.js'
import { getLanguageStr } from '@/util/language.js'
export default {
  name: 'Weather',
  components: { Loading },
  data () {
    return {
      isLoading: false,
      // basicInfo:{},
      weatherAddress: {}, // 天气地址
      weahterRegion: null,
      weatherState: [], // 天气状态,
      error: false
    }
  },
  computed: {
    ...mapGetters({
      preference: 'user/preference'
    })
  },
  methods: {
    ...mapMutations({
      GET_WEATHER: 'stationDetail/GET_WEATHER'
    }),
    getLanguageStr,
    floatFix: lib.floatFix,
    getTypeText: lib.getTypeText,
    timeFormat: lib.timeFormat,
    tempChange: lib.tempChange,
    show (data) {
      this.basicInfo = data.basicInfo
      this._weather()
      // if(data.basicInfo){
      //
      //     this._weather()
      // }else{
      //     this._getBasicInfo(data.id)
      // }
    },
    TimeFormat (data) {
      return lib.timeFormat(data, 'utc', '%H:%M', { offset: this.basicInfo.region.timezone })
    },
    // 获取详情-电站信息
    // _getBasicInfo(id){
    // 	equipmentApi.StationBasicInfo(id).then(response=>{
    // 		this.basicInfo=response
    // 		this._weather(); //根据返回信息，查找天气
    // 	},error=>{
    //         !_.isEmpty(error) && this.$notify(error)
    // 	})
    // },
    getWeek (val) {
      let week = ['日', '一', '二', '三', '四', '五', '六']
      let yWeek = ['word146', 'word140', 'word141', 'word142', 'word143', 'word144', 'word145']
      let thisDay = new Date().getTime() + 1000 * 60 * 60 * 24 * val
      let day = lib.timeFormat(thisDay / 1000, 'utc', '%Y/%m/%d')
      let finalweek = new Date(day).getDay()
      return getLanguageStr(yWeek[finalweek], ['周' + week[finalweek]])
    },
    getDay (val) {
      let thisDay = new Date().getTime() + 1000 * 60 * 60 * 24 * val
      return new Date(thisDay).getMonth() + 1 + '/' + new Date(thisDay).getDate()
    },
    // 获取天气
    _weather () {
      this.isLoading = true
      this.error = false
      this.getWeather().then(res => {
        if (res) {
          this.error = false
          this.weahterRegion = res.regionName
          this.weatherState = res.weatherList // 天气状态
          this.GET_WEATHER(res.weatherList)
        } else {
          this.error = true
        }
        this.isLoading = false
      }, error => {
        this.error = true
        this.isLoading = false
      })
      // Promise.all([this.getWeather()]).then(res=>{
      // 	if(res){
      // 		this.error=false
      // 		this.weahterRegion=res[0].regionName
      // 		this.weatherState=res[0].weatherList //天气状态
      // 		this.GET_WEATHER(res[0].weatherList)
      // 	}
      // 	else{
      // 		this.error=true
      // 	}
      // 	this.isLoading=false
      // },error=>{
      // 	this.error=true
      // 	this.isLoading=false
      // 	// !_.isEmpty(error) && this.$notify(error)
      // })
    },
    // 获取天气
    getWeather () {
      let address = {
        // 'longitude':this.basicInfo.location.lng.toString(),
        // 'latitude':this.basicInfo.location.lat.toString(),
        regionNationId: this.basicInfo.region.nationId,
        regionLevel1: this.basicInfo.region.level1,
        regionLevel2: this.basicInfo.region.level2
      }
      return new Promise((resolve, reject) => {
        weatherState(address).then(response => {
          resolve(response)
        }, error => {
          reject(error)
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.panel .title {
  margin-bottom: 0;
}
#weatherInfo .icoSys svg {
  padding: 10%;
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/detail/Weather.vue